import CanvasLayoutStateScaffold from './CanvasLayoutStateScaffold';

export default function CanvasLayoutLoading() {
  return <CanvasLayoutStateScaffold isAnimated={true} />;
}
